module.exports = __webpack_public_path__ + "static/media/menu_transactionFees_default.487ef3de.svg";